import { InvoiceSituation } from '@/core/domain/invoice/invoices/invoices.enums';
import useValidateRoutes from '@/hooks/useValidateRoutes';
import { RouteType } from '@/types/RouteType';

export default function invoiceValidateRoutes(
  route: RouteType,
  situation?: InvoiceSituation,
) {
  const useHook = () => {
    return useValidateRoutes({
      route: route.parent,
      validation: situation !== 'AUTHORIZED',
      keys: ['acc-e'],
    });
  };

  return useHook();
}
